// src/pages/produtos/unMedida/UnMedidaSearch.js
import React, { useEffect, useState, useRef } from 'react';
import { useUnMedida } from '../../../contexts/produtos/UnMedidaContext';
import { FaSortUp, FaSortDown } from "react-icons/fa";

import ModalTable from '../../../components/modalForm/ModalTable';
import ModalContainer from '../../../components/modalForm/ModalContainer';
import LazyLoading from '../../../components/modalForm/LazyLoading';
import ModalHeader from '../../../components/modalForm/ModalHeader';
import ModalBody from '../../../components/modalForm/ModalBody';
import ModalFooter from '../../../components/modalForm/ModalFooter';
import ModalSearchBar from '../../../components/modalForm/ModalSearchBar';
import { ModalActionButton } from '../../../components/modalForm/ModalActions';
import ModalSelectButton from '../../../components/modalForm/ModalSelectButton';

const UnMedidaSearch = ({ show, onHide, onSelectUnMedida }) => {
    const { unMedidas } = useUnMedida();
    const [filter, setFilter] = useState('');
    const [sortField, setSortField] = useState('sigla'); // 'sigla' ou 'descricao'
    const [sortDirection, setSortDirection] = useState('asc'); // 'asc' ou 'desc'

    const inputRef = useRef(null);

    useEffect(() => {
        if (show) {
            setFilter('');
            if (inputRef.current) {
                inputRef.current.focus();
            }
        }
    }, [show]);

    if (!show) return null;

    const filteredUnMedidas = (unMedidas || []).filter(unMedida =>
        unMedida && (unMedida.descricao || "").toLowerCase().includes((filter || "").toLowerCase())
    );

    const sortedUnMedidas = filteredUnMedidas.sort((a, b) => {
        if (sortField === 'sigla') {
            const siglaA = (a.sigla || "").toLowerCase();
            const siglaB = (b.sigla || "").toLowerCase();
            return sortDirection === 'asc' ? siglaA.localeCompare(siglaB) : siglaB.localeCompare(siglaA);
        } else if (sortField === 'descricao') {
            const descriptionA = (a.descricao || "").toLowerCase();
            const descriptionB = (b.descricao || "").toLowerCase();
            return sortDirection === 'asc' ? descriptionA.localeCompare(descriptionB) : descriptionB.localeCompare(descriptionA);
        }
        return 0;
    });

    const handleSort = (field) => {
        if (sortField === field) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            setSortField(field);
            setSortDirection('asc');
        }
    };

    const handleDoubleClick = (unMedida) => {
        onSelectUnMedida(unMedida);
        onHide();
    };

    return (
        <ModalContainer show={show} variant="busca" onHide={onHide}>
            <ModalHeader title="Buscar Unidade de Medida" onHide={onHide} />
            <ModalBody className="modal-body">
                <div className="mb-3">
                    <ModalSearchBar
                        inputRef={inputRef}
                        type="text"

                        placeholder="Filtrar por descrição..."
                        value={filter}
                        onChange={(e) => setFilter(e.target.value)}
                    />
                </div>

                <LazyLoading
                    items={sortedUnMedidas}
                    resetKey={`${filter}|${sortField}|${sortDirection}`}
                >
                {({ containerRef, handleScroll, visibleItems }) => (
                <ModalTable
                    containerRef={containerRef}
                    containerStyle={{ maxHeight: '55vh', overflowY: 'auto' }}
                    onContainerScroll={handleScroll}
                >
                    <thead style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                        <tr>
                            <th className="text-center align-middle" scope="col" style={{ width: '10%' }} aria-sort={sortField === 'sigla' ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}>
                                <button onClick={() => handleSort('sigla')} 
                                    style={{ fontWeight: 'bold', background: 'none', border: 'none' }}
                                    tabIndex={0}
                                 type="button">
                                    Sigla
                                    {sortField === 'sigla' && (sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />)}
                                </button>
                            </th>
                            <th className="align-middle" scope="col" style={{ width: '60%' }} aria-sort={sortField === 'descricao' ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}>
                                <button onClick={() => handleSort('descricao')} 
                                    style={{ fontWeight: 'bold', background: 'none', border: 'none' }}
                                    tabIndex={0}
                                 type="button">
                                    Descrição
                                    {sortField === 'descricao' && (sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />)}
                                </button>
                            </th>
                            <th className="text-center align-middle modal-select-column" scope="col" style={{ width: '20%' }}>Selecionar</th>
                        </tr>
                    </thead>
                    <tbody>
                        {visibleItems.map(unMedida => (
                            <tr key={unMedida.sigla} onDoubleClick={() => handleDoubleClick(unMedida)}>
                                <td className="text-center align-middle">{unMedida.sigla}</td>
                                <td className="align-middle">{unMedida.descricao}</td>
                                <td className="text-center align-middle modal-select-column">
                                    <ModalSelectButton
                                        className="btn btn-outline-secondary btn-sm"
                                        onClick={() => onSelectUnMedida(unMedida)}
                                        style={{ padding: '2px 6px' }}
                                     label={unMedida.descricao} />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </ModalTable>
                )}
                </LazyLoading>
            </ModalBody>
            <ModalFooter className="modal-footer">
                <ModalActionButton type="button" className="btn btn-secondary btn-sm" onClick={onHide} action="close">
                    Fechar
                </ModalActionButton>
            </ModalFooter>
        </ModalContainer>
    );
};

export default UnMedidaSearch;
